import { METRIC } from '../metricsList';

const product = window.conviva.module || 'Activation';

const IMPACTED_ATTEMPTS_NAME = 'Impacted Attempts';
const PCT_ATTEMPTS = '% Attempts';

const IMPACTED_PLAYS = product === 'EI' ? 'VPF' : 'Impacted Ended Plays';
const IMPACTED_PLAYS_BUSINESS = 'VPF-B';
const IMPACTED_PLAYS_TECH = 'VPF-T';
const PCT_ENDED_PLAYS = '% Ended Plays';

const ERROR_CODE_NAME = 'Error Code';
const BUSINESS_ERROR_CODE_NAME = 'Business Error Code';
const TECHNICAL_ERROR_CODE_NAME = 'Technical Error Code';

const ERROR_CODE_VSF = 'VSF_ERROR';
const ERROR_CODE_VPF = 'VPF_ERROR';
const ERROR_CODE_AWE = 'AD_ERROR';
const ERROR_CODE_VSFB = 'VSF_BUSINESS_ERROR';
const ERROR_CODE_VSFT = 'VSF_TECH_ERROR';
const ERROR_CODE_VPFB = 'VPF_BUSINESS_ERROR';
const ERROR_CODE_VPFT = 'VPF_TECH_ERROR';

const ERROR_METRIC_MAP = {
  [METRIC.VideoStartFailures]: ERROR_CODE_VSF,
  [METRIC.VideoPlaybackFailures]: ERROR_CODE_VPF,
  [METRIC.VideoStartFailuresBusiness]: ERROR_CODE_VSFB,
  [METRIC.VideoStartFailuresTech]: ERROR_CODE_VSFT,
  [METRIC.VideoPlaybackFailuresBusiness]: ERROR_CODE_VPFB,
  [METRIC.VideoPlaybackFailuresTech]: ERROR_CODE_VPFT,
  [METRIC.AdsWithErrors]: ERROR_CODE_AWE,
};
// Adding a new param queryMetric for CSR-6273
const ERROR_DIMENSION_MAP = {
  [ERROR_CODE_VSF]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: METRIC.Attempts,
    primary: METRIC.VideoStartFailures,
    queryMetric: METRIC.Attempts,
    dimension: ERROR_CODE_VSF,
    header: ERROR_CODE_NAME,
  },
  [ERROR_CODE_VSFB]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: METRIC.Attempts,
    primary: METRIC.VideoStartFailuresBusiness,
    queryMetric: METRIC.Attempts,
    dimension: ERROR_CODE_VSFB,
    header: BUSINESS_ERROR_CODE_NAME,
  },
  [ERROR_CODE_VSFT]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: METRIC.Attempts,
    primary: METRIC.VideoStartFailuresTech,
    queryMetric: METRIC.Attempts,
    dimension: ERROR_CODE_VSFT,
    header: TECHNICAL_ERROR_CODE_NAME,
  },
  [ERROR_CODE_VPF]: {
    columnName: IMPACTED_PLAYS,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: METRIC.EndedPlays,
    primary: METRIC.VideoPlaybackFailures,
    queryMetric: METRIC.VideoPlaybackFailures,
    dimension: ERROR_CODE_VPF,
    header: ERROR_CODE_NAME,
  },
  [ERROR_CODE_VPFB]: {
    columnName: IMPACTED_PLAYS_BUSINESS,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: METRIC.EndedPlays,
    primary: METRIC.VideoPlaybackFailuresBusiness,
    queryMetric: METRIC.VideoPlaybackFailuresBusiness,
    dimension: ERROR_CODE_VPFB,
    header: BUSINESS_ERROR_CODE_NAME,
  },
  [ERROR_CODE_VPFT]: {
    columnName: IMPACTED_PLAYS_TECH,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: METRIC.EndedPlays,
    primary: METRIC.VideoPlaybackFailuresTech,
    queryMetric: METRIC.VideoPlaybackFailuresTech,
    dimension: ERROR_CODE_VPFT,
    header: TECHNICAL_ERROR_CODE_NAME,
  },
  [ERROR_CODE_AWE]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: METRIC.Attempts,
    primary: METRIC.AdsWithErrors,
    queryMetric: METRIC.Attempts,
    dimension: ERROR_CODE_AWE,
    header: ERROR_CODE_NAME,
  },
};

export const isErrorCodeByDimension = (dimension) => dimension in ERROR_DIMENSION_MAP;
export const isErrorCodeByMetric = (metric) => metric in ERROR_METRIC_MAP;
export const getErrorCodeDimension = (metric) => ERROR_METRIC_MAP[metric];

export const getErrorMetricInfo = (metric) => {
  const dimension = getErrorCodeDimension(metric);
  return ERROR_DIMENSION_MAP[dimension] || {};
};
export const getErrorDimensionInfo = (dimension) => ERROR_DIMENSION_MAP[dimension] || {};

export const findErrorCodeMetric = (metrics) => metrics.find(isErrorCodeByMetric);
